module.exports = __webpack_public_path__ + "static/media/techLead.66b786fb.jpg";